import PropTypes from 'prop-types';
import { values } from 'ramda';

export const THEMATIC = {
  BANK: 'bank',
  DIGITAL: 'digital',
  DT: 'dt',
  ECOLOGY: 'ecology',
  LOGISTICS: 'logistics',
  PEOPLE: 'people',
};

export const ThematicType = PropTypes.oneOf(values(THEMATIC));
